module.exports = __webpack_public_path__ + "img/jh1.9d1c5ff9.jpg";